import { useContext } from 'react';
import { TailwindThemeContext } from '../../contexts/tailwindThemeContext';

const useColors = () => {
  const context = useContext(TailwindThemeContext);
  if (context === undefined) throw new Error('Invalid tailwind theme context.');

  const setColors = (colors: Record<string, any>) => {
    context.setTailwind({
      theme: {
        extend: {
          ...context.tailwind.theme.extend,
          colors,
        },
      },
    });
  };

  return {
    colors: context.tailwind?.theme?.extend?.colors ?? null,
    setColors,
  };
};

export { useColors };
